import { useVisibleContainer } from "../hooks/useVisibleContainer";

// Route-effect component for "/profile/sessions". Renders nothing -
// SessionsScreen.tsx (mounted unconditionally in AppRoot) owns the actual
// rendering into #profileSessionsView, same pattern as every other route
// screen (see GiftsRouteScreen.tsx).
export function SessionsRouteScreen() {
  useVisibleContainer("profileSessionsView");
  return null;
}
